import UserAvatar from "Areas/SharedFeatures/userAvatar";
import { accessLevelAccessLocale } from "Common/dictionaries/accessLevelAccess";
import { ButtonWithTooltip } from "Components/button";
import ProgressOverlay from "Components/progressOverlay";
import RotatedArrow from "Components/rotatedArrow";
import Scrollbars from "Components/scrollbars";
import SlideUpDown from "Components/slideUpDown";
import { themeVariables } from "Components/theme";
import classNames from "classnames";
import keyBy from "lodash/keyBy";
import map from "lodash/map";
import React, { useCallback, useEffect, useMemo } from "react";
import locale from "./accessLevels.locale";
import Styled, { SIZES } from "./accessLevels.styled";
const mainContainerStyle = {
    minWidth: SIZES.MIN_WIDTH
};
const emptyAvatarStyle = {
    width: SIZES.AVATAR_SIZE,
    height: SIZES.AVATAR_SIZE
};
export const SLIDE_DOWN_SIZES = {
    ROW_ACTIONS_PANEL_HEIGHT: 44
};
const slideUpDownStyle = {
    position: "absolute",
    top: SLIDE_DOWN_SIZES.ROW_ACTIONS_PANEL_HEIGHT,
    right: 0,
    zIndex: themeVariables["zindex-devextreme-dx-menu-base"]
};
const titleStyle = {
    padding: SIZES.TITLE_PADDINGS
};
export default function AccessLevels(props) {
    var _a, _b;
    useEffect(() => {
        props.entityId &&
            props.entityType &&
            props.onInitialized &&
            props.onInitialized(props.entityId, props.entityType);
    }, [props.entityId, props.entityType]);
    const usersByKey = useMemo(() => props.users && keyBy(props.users, "Id"), [props.users]);
    const handleAddClicked = useCallback((e) => {
        var _a;
        (_a = e.event) === null || _a === void 0 ? void 0 : _a.stopPropagation();
        props.onCreate && props.onCreate();
    }, [props.onCreate]);
    const handleEditClicked = useCallback((e) => {
        var _a;
        (_a = e.event) === null || _a === void 0 ? void 0 : _a.stopPropagation();
        props.onEdit && props.onEdit(props.entityId, props.entityType);
    }, [props.onEdit, props.entityId, props.entityType]);
    const handleToggleSlideDownOpen = useCallback(() => {
        props.onChangeOpen && props.onChangeOpen(!props.open);
    }, [props.open, props.onChangeOpen]);
    const members = useMemo(() => (React.createElement(Scrollbars, { extraRightSpace: true },
        React.createElement("div", null, map(props.data, accessLevel => {
            var _a;
            let userDelete = false;
            let user = usersByKey && usersByKey[accessLevel.UserId];
            if (user === undefined && accessLevel.UserId === ((_a = props.userCreate) === null || _a === void 0 ? void 0 : _a.Id)) {
                userDelete = true;
                user = props.userCreate;
            }
            return (React.createElement("div", { key: accessLevel.UserId, className: "flex-space-between mt-gap" },
                React.createElement("div", { className: "d-flex v-center-items overflow-hidden pr-0_75" },
                    user ? (React.createElement(UserAvatar, { size: SIZES.AVATAR_SIZE, userId: user.Id, login: user.Login, fullName: user.FullName, className: "flex-no-shrink", isParticipant: true })) : (React.createElement("div", { className: "flex-no-shrink", style: emptyAvatarStyle })),
                    React.createElement("div", { className: "ml-xxs d-flex overflow-hidden" },
                        React.createElement("div", { className: "text-overflow-ellipsis nowrap" }, user === null || user === void 0 ? void 0 : user.FullName),
                        props.selfUserId === (user === null || user === void 0 ? void 0 : user.Id) && (React.createElement("span", { className: "ml-xxxs text-primary-500" },
                            "(",
                            locale.YOU,
                            ")")),
                        userDelete && (React.createElement("span", { className: "ml-xxxs text-danger-500" },
                            "(",
                            locale.USER_DELETED,
                            ")")))),
                React.createElement(Styled.AccessBadge, null, accessLevelAccessLocale[accessLevel.Access])));
        })))), [props.data, props.selfUserId]);
    return (React.createElement("div", { className: classNames(props.className, "h-100"), style: mainContainerStyle },
        React.createElement(ProgressOverlay, { show: props.inProgress },
            React.createElement("div", { className: "grid-rows-auto-1fr border-bottom" },
                React.createElement("div", { className: "flex-space-between clickable", onClick: handleToggleSlideDownOpen, style: { height: 44 } },
                    React.createElement("div", { className: "d-flex pl-1 pr-1 v-center-items" },
                        React.createElement(RotatedArrow, { className: "flex-box-centered-content text-light-on-surface-variant", open: props.open, size: 16 }),
                        React.createElement("div", { className: "ml-1", style: titleStyle }, locale.TITLE)),
                    props.data && props.users && (React.createElement("div", { className: "d-flex v-center-items with-gap-26" },
                        React.createElement(ButtonWithTooltip, { className: "no-border no-default-colors p-0 text-light-on-surface-variant", onClick: handleAddClicked, popoverContent: locale.ADD_USER_ACCESS },
                            React.createElement("i", { className: "icon-new-plus text-light-on-surface-variant" })),
                        React.createElement(ButtonWithTooltip, { className: "no-border no-default-colors p-0 mr-31 text-light-on-surface-variant", onClick: handleEditClicked, popoverContent: locale.EDIT_USER_ACCESS },
                            React.createElement("i", { className: "icon-pencil-minus text-light-on-surface-variant" }))))),
                React.createElement(SlideUpDown, { className: "w-100 w-100-max border bg-body pl-16 pr-20 pb-1", open: Boolean(props.open), style: {
                        ...slideUpDownStyle,
                        top: (_a = props.slideDownTop) !== null && _a !== void 0 ? _a : slideUpDownStyle.top
                    }, unmountOnExit: true, openedHeight: props.openedHeight
                        ? props.openedHeight -
                            ((_b = props.slideDownTop) !== null && _b !== void 0 ? _b : SLIDE_DOWN_SIZES.ROW_ACTIONS_PANEL_HEIGHT)
                        : 0 }, members)))));
}
